<template>
  <div id="page-alldemands" class="d-flex">
    <MainBarMenu />
    <!-- <div class="header-top">
      <div class="container-fluid">
        <HeadingUser />
      </div>
    </div> -->
    <div class="layout-content container-fluid">
      <HeadingUser />
      <div class="row mt-5 mt-md-5">
        <div class="col-12 col-md-8">
          <h2 class="mt-0 mt-md-3 mt-lg-4">Solicitudes</h2>
          <small v-if="(PS_ROLES.APROBADOR, PS_ROLES.BP)" class="text-dark">
            Filtrar información
          </small>
        </div>
        <!-- .col -->
        <!-- buscar -->
        <div class="col-12 col-md-4 text-left text-lg-right mb-3">
          <div
            class="cont-search d-flex flex-column align-items-start align-items-md-end"
          >
            <label for="filter d-block">Busca una solicitud por ID</label>
            <div class="cont-input d-flex">
              <!-- filtrar permisos sindicales -->
              <input
                v-if="typeReport == 1"
                type="text"
                class="input-text"
                v-model="datatable.filter"
                placeholder="Introduce tu búsqueda..."
                @keyup="$event.stopImmediatePropagation(), getFilterAdv()"
              />
              <!-- filtrar Drechos de Petición -->
              <input
                v-if="typeReport == 2"
                type="text"
                class="input-text"
                v-model="datatableDP.filter"
                placeholder="Introduce tu búsqueda..."
                @keyup="$event.stopImmediatePropagation(), getFilterDp()"
              />
              <button class="d-flex align-items-center px-3">
                <span>Buscar</span>
                <span class="icon icon-search ml-3"></span>
              </button>
            </div>
          </div>
        </div>
        <!-- end -->
        <!-- filtros -->
        <div
          class="row col-12 ml-4 mb-1"
          v-if="canWithCode(PS_ROLES.APROBADOR, PS_ROLES.RELACIONES_LABORALES)"
        >
          <div
            class="row col-9"
            style="background-color: #e5e5e5; min-height: 60px"
            v-if="canWithCode(PS_ROLES.APROBADOR)"
          >
            <div class="col-2 mt-4 mr-2">
              <b-form-select
                v-model="selected_ticket_state"
                :options="list_ticket_status"
                size="lg"
              />
            </div>
            <div class="col-3 mt-4 mr-5">
              <b-form-select
                v-model="selected_request_state"
                :options="list_request_status"
                @change="change_select_request_state"
                size="lg"
              />
            </div>
            <div class="col-3 mt-4 mr-5">
              <b-form-select
                id="input-select-labor-union"
                v-model="selected_labor_union"
                :options="mapperOfMyLaborUnionGetter"
                @change="change_select_request_labor_union"
                size="lg"
              />
            </div>
            <div class="mt-4">
              <!-- apply filters -->
              <b-button
                :disabled="disable_button_to_filter"
                class="mr-5"
                pill
                style="background-color: #1c3a4e; color: #ffffff"
                size="lg"
                @click.prevent="apply_filters"
              >
                Aplicar filtros
                <span class="icon icon-checkmark mr-1" />
              </b-button>
              <!-- end -->
              <!-- reset filters -->
              <b-button
                :disabled="disable_button_to_filter"
                variant="link"
                style="color: #da1414"
                size="lg"
                @click.prevent="reset_filters"
              >
                Borrar filtros
                <span class="icon icon-bin mr-1" />
              </b-button>
              <!-- end -->
            </div>
          </div>
          <!-- Si no tiene el permiso se acomoda a la clase de col-12 ml-0 -->
          <div
            :class="`${
              canWithCode(PS_ROLES.RELACIONES_LABORALES)
                ? 'col ml-0'
                : 'col ml-5'
            } d-flex justify-content-end align-items-end`"
          >
            <!-- boton del reporte PS -->
            <button
              @click.prevent="$refs.consolidatedReport.show()"
              class="btn-reporte td4 mb-4 rounded-lg btn-lg"
              style="width: auto; padding-right: 10px; padding-left: 10px"
            >
              <img
                class="leftImg1"
                src="@/assets/images/icons/excel.svg"
                alt="null"
              />
              <u> Reporte Consolidado PS </u>
            </button>
            <!-- end -->
          </div>
        </div>
        <!-- end -->

        <!-- filters business partners -->
        <template v-if="canWithCode(PS_ROLES.BP)">
          <!-- filtros -->
          <b-col cols="12" lg="9">
            <b-row class="filters-bp ml-0">
              <b-col cols="12" lg="9">
                <b-row>
                  <b-col cols="12" lg="4" class="mt-2">
                    <b-form-select
                      v-model="business_partners_selected_ticket_state"
                      :options="list_ticket_status"
                      size="lg"
                    />
                  </b-col>
                  <b-col cols="12" lg="4" class="mt-2">
                    <b-form-select
                      v-model="business_partners_selected_request_state"
                      :options="list_request_status"
                      size="lg"
                    />
                  </b-col>
                  <b-col cols="12" lg="4" class="mt-2">
                    <b-form-input
                      v-model="business_partners_collaborator"
                      :options="list_request_status"
                      placeholder="Escribe nombre o cédula del colaborador"
                      size="lg"
                    />
                  </b-col>
                  <b-col cols="12" lg="4" class="mt-2">
                    <b-form-datepicker
                      id="business-partners-start-date-datepicker"
                      v-model="business_partners_star_date"
                      :date-format-options="{
                        year: 'numeric',
                        month: '2-digit',
                        day: '2-digit',
                      }"
                      type="text"
                      placeholder="Fecha de Inicio del permiso"
                      autocomplete="off"
                      size="lg"
                    />
                  </b-col>
                  <b-col cols="12" lg="4" class="mt-2">
                    <b-form-datepicker
                      id="business-partners-end-date-datepicker"
                      v-model="business_partners_end_date"
                      :min="business_partners_star_date"
                      :disabled="!business_partners_star_date"
                      :readonly="!business_partners_star_date"
                      :date-format-options="{
                        year: 'numeric',
                        month: '2-digit',
                        day: '2-digit',
                      }"
                      type="text"
                      placeholder="Fecha fin del permiso"
                      autocomplete="off"
                      size="lg"
                    />
                  </b-col>
                  <b-col cols="12" lg="4" class="mt-2">
                    <b-form-select
                      id="input-select-labor-union"
                      v-model="selected_labor_union"
                      :options="mapperOfMyLaborUnionGetter"
                      @change="change_select_request_labor_union"
                      size="lg"
                    />
                  </b-col>
                </b-row>
              </b-col>
              <b-col cols="12" lg="3" class="pt-4 pt-lg-0">
                <b-button
                  :disabled="business_partners_disable_button_to_filter"
                  pill
                  style="background-color: #1c3a4e; color: #ffffff"
                  size="lg"
                  @click.prevent="businessPartnerApplyFilters"
                >
                  Aplicar filtros
                  <span class="icon icon-checkmark mr-1" />
                </b-button>
                <b-button
                  :disabled="business_partners_disable_button_to_filter"
                  variant="link"
                  style="color: #da1414"
                  size="lg"
                  @click.prevent="businessPartnerResetFilters"
                >
                  Borrar filtros
                  <span class="icon icon-bin mr-1" />
                </b-button>
              </b-col>
            </b-row>
          </b-col>

          <!-- reporte -->
          <b-col
            cols="12"
            lg="3"
            class="d-flex flex-column align-items-start align-items-lg-end pt-lg-4 pt-2"
          >
            <button
              class="btn-reporte"
              @click.prevent="$refs.consolidatedReport.show()"
            >
              <img
                class="leftImg1"
                src="@/assets/images/icons/excel.svg"
                alt="download-report"
              />
              <u> Reporte Consolidado PS</u>
            </button>
          </b-col>
        </template>
        <!-- end -->

        <!-- alert -->
        <div class="col-12">
          <b-skeleton-wrapper :loading="getSettingGetter.processing">
            <template #loading>
              <b-alert show variant="dark">
                <b-skeleton width="95%"></b-skeleton>
                <b-skeleton width="65%"></b-skeleton>
                <b-skeleton width="80%"></b-skeleton>
              </b-alert>
            </template>
            <toaster-informative
              hide-circle-to-icon
              :show="canWithCode(PS_ROLES.APROBADOR)"
              :message="message_of_request_state"
            />
          </b-skeleton-wrapper>
        </div>
        <!-- end -->
      </div>
      <!-- end -->

      <br />

      <div v-if="userRolView">
        <b-card no-body class="mb-1" style="background: #e9ecee">
          <b-card-header header-tag="header" class="p-1" role="tab">
            <b-button
              class="button1"
              block
              v-b-toggle.accordion-1
              variant="info"
            >
              Filtros avanzados
              <span class="when-opened">
                <img
                  class="centerImg1"
                  src="@/assets/images/icons/chevron-up.svg"
                />
              </span>
              <span class="when-closed">
                <img
                  class="centerImg1"
                  src="@/assets/images/icons/chevron-down.svg"
                />
              </span>
            </b-button>
          </b-card-header>
          <b-collapse
            id="accordion-1"
            accordion="my-accordion"
            role="tabpanel"
            align="left"
          >
            <b-card-body>
              <table class="tabla1" border="0" width="100%">
                <thead>
                  <tr>
                    <td v-if="userRolView2" class="td1">Tipo de solicitud</td>
                    <td v-if="typeReport == 2" class="td1 text-left">
                      Filtrar por usuario
                    </td>
                    <!-- <td class="td1">Rango de tiempo</td> -->
                    <td class="td1">Estado</td>
                  </tr>
                  <tr>
                    <td width="120px" class="px-0 my-5">
                      <div class="custom-control custom-radio">
                        <input
                          class="custom-control-input"
                          type="radio"
                          name="tipoSol"
                          id="id1"
                          v-on:change="tipoSolicitud(1)"
                        />
                        <label class="custom-control-label" for="id1"
                          ><p class="p2">Permisos sindicales</p></label
                        >
                      </div>
                      <div class="custom-control custom-radio">
                        <input
                          class="custom-control-input"
                          type="radio"
                          name="tipoSol"
                          id="id2"
                          v-on:change="tipoSolicitud(2)"
                        />
                        <label class="custom-control-label" for="id2"
                          ><p class="p2">Derechos de petición</p></label
                        >
                      </div>
                      <!--p class="p2"><input class="form-check-input mycheck" type="checkbox">
                    Derechos de peticion</p>
                    <p class="p2"><input class="form-check-input mycheck" type="checkbox">
                    Procesos disciplinarios</p-->
                    </td>
                    <!-- <td class="td2" width="120px">
                      <p class="p2">Inicio:
                        <b-form-datepicker
                          v-model="fechaIni"
                          reset-button
                          @input = "getFilterAdv"
                          :date-format-options="{ year: 'numeric' , month: 'numeric', day: 'numeric' }"
                          class="mb-2">
                        </b-form-datepicker>
                      </p>
                      <p class="p2">Fin:
                        <b-form-datepicker
                          v-model="fechaFin"
                          reset-button
                          @input = "getFilterAdv"
                          :date-format-options="{ year: 'numeric' , month: 'numeric', day: 'numeric' }"
                          class="mb-2">
                        </b-form-datepicker>
                      </p>
                  </td> -->

                    <!-- Filtro por Usuario (Respondables y subresponsables Relaciones Laborales-->
                    <td
                      v-if="
                        typeReport == 2 &&
                        (user.core_role_id == 4 || user.core_role_id == 10)
                      "
                      class="td2 px-0 my-5"
                    >
                      <div class="custom-control custom-radio">
                        <input
                          class="custom-control-input"
                          type="radio"
                          v-model="filterDP.id"
                          v-on:change="getFilterDp"
                          :value="true"
                          id="Check1"
                        />
                        <label class="custom-control-label" for="Check1">
                          <p>Mis derechos de Petición</p>
                        </label>
                      </div>
                      <div class="custom-control custom-radio">
                        <input
                          class="custom-control-input"
                          type="radio"
                          v-model="filterDP.id"
                          v-on:change="getFilterDp"
                          :value="false"
                          id="Check2"
                        />
                        <label class="custom-control-label" for="Check2">
                          <p>Todos los Derechos Petición</p>
                        </label>
                      </div>
                    </td>

                    <!-- Filtro por Usuario (Business Partner)-->
                    <td
                      v-if="typeReport == 2 && user.core_role_id == 2"
                      class="td2 px-0 my-5"
                    >
                      <div class="custom-control custom-radio">
                        <input
                          class="custom-control-input"
                          type="radio"
                          v-model="filterDP.bp"
                          v-on:change="getFilterDp"
                          :value="user.id"
                          id="Check1bp"
                        />
                        <label class="custom-control-label" for="Check1bp">
                          <p>Mis derechos de Petición</p>
                        </label>
                      </div>
                      <div class="custom-control custom-radio">
                        <input
                          class="custom-control-input"
                          type="radio"
                          v-model="filterDP.bp"
                          v-on:change="getFilterDp"
                          :value="0"
                          id="Check2bp"
                        />
                        <label class="custom-control-label" for="Check2bp">
                          <p>Todos los Derechos Petición</p>
                        </label>
                      </div>
                    </td>
                    <!-- Filtro por Estado del Derecho de Peticion-->

                    <td
                      v-if="typeReport == 2"
                      class="td2 px-0 d-lg-flex flex-lg-wrap my-5"
                    >
                      <div class="custom-control custom-checkbox col-lg-12">
                        <input
                          class="custom-control-input"
                          type="checkbox"
                          v-model="filterDP.state"
                          v-on:change="getFilterDp"
                          value="pending"
                          id="Check4"
                          for="stateDP"
                        />
                        <label class="custom-control-label" for="Check4">
                          <p class="p2">
                            <img
                              class="leftImg1"
                              src="@/assets/images/icons/circle-clock.svg"
                            />
                            Pendiente
                          </p>
                        </label>
                      </div>
                      <div class="custom-control custom-checkbox col-lg-12">
                        <input
                          class="custom-control-input"
                          type="checkbox"
                          v-model="filterDP.state"
                          v-on:change="getFilterDp"
                          value="open"
                          id="Check5"
                          for="stateDP"
                        />
                        <label class="custom-control-label" for="Check5">
                          <p class="p2">
                            <img
                              class="leftImg1"
                              src="@/assets/images/icons/circle-clock.svg"
                            />
                            Abierto
                          </p>
                        </label>
                      </div>
                      <div class="custom-control custom-checkbox col-lg-12">
                        <input
                          class="custom-control-input"
                          type="checkbox"
                          v-model="filterDP.state"
                          v-on:change="getFilterDp"
                          value="closing"
                          id="Check6"
                          for="stateDP"
                        />
                        <label class="custom-control-label" for="Check6">
                          <p class="p2">
                            <img
                              class="leftImg1"
                              src="@/assets/images/icons/eye.svg"
                            />
                            Cerrando
                          </p>
                        </label>
                      </div>
                      <div class="custom-control custom-checkbox col-lg-12">
                        <input
                          class="custom-control-input"
                          type="checkbox"
                          v-model="filterDP.state"
                          v-on:change="getFilterDp"
                          value="closed"
                          id="Check7"
                          for="stateDP"
                        />
                        <label class="custom-control-label" for="Check7">
                          <p class="p2">
                            <img
                              class="leftImg1"
                              src="@/assets/images/icons/circle-check.svg"
                            />
                            Cerrado
                          </p>
                        </label>
                      </div>
                    </td>
                    <td
                      v-if="typeReport == 1"
                      class="td2 px-0 my-5"
                      width="120px"
                    >
                      <div class="custom-control custom-checkbox">
                        <input
                          class="custom-control-input"
                          type="checkbox"
                          v-model="estado"
                          v-on:change="getFilterAdv"
                          value="closed"
                          id="Check1"
                        />
                        <label class="custom-control-label" for="Check1">
                          <p class="p2">
                            <img
                              class="leftImg1"
                              src="@/assets/images/icons/circle-check.svg"
                            />
                            Cerrado
                          </p>
                        </label>
                      </div>
                      <div class="custom-control custom-checkbox">
                        <input
                          class="custom-control-input"
                          type="checkbox"
                          v-model="estado"
                          v-on:change="getFilterAdv"
                          value="pending"
                          id="Check2"
                        />
                        <label class="custom-control-label" for="Check2">
                          <p class="p2">
                            <img
                              class="leftImg1"
                              src="@/assets/images/icons/circle-clock.svg"
                            />
                            Pendiente
                          </p>
                        </label>
                      </div>
                      <div class="custom-control custom-checkbox">
                        <input
                          class="custom-control-input"
                          type="checkbox"
                          v-model="estado"
                          v-on:change="getFilterAdv"
                          value="review"
                          id="Check3"
                        />
                        <label class="custom-control-label" for="Check3">
                          <p class="p2">
                            <img
                              class="leftImg1"
                              src="@/assets/images/icons/eye.svg"
                            />
                            En revisión
                          </p>
                        </label>
                      </div>
                    </td>
                  </tr>
                </thead>
              </table>
            </b-card-body>
          </b-collapse>
        </b-card>
        <b-row class="my-4">
          <b-col cols="12">
            <table class="ml-auto">
              <tr>
                <td v-if="typeReport == 2">
                  <a
                    v-if="typeReport == 2"
                    :href="serverPath + '/petitionRightsExport'"
                    download
                    class="btn-reporte"
                  >
                    <img
                      class="leftImg1"
                      src="@/assets/images/icons/excel.svg"
                    />
                    <u> Reporte Consolidado DP</u>
                  </a>
                </td>
                <td v-if="typeReport === 1">
                  <button
                    class="btn-reporte"
                    @click.prevent="$refs.consolidatedReport.show()"
                  >
                    <img
                      class="leftImg1"
                      src="@/assets/images/icons/excel.svg"
                    />
                    <u> Reporte Consolidado PS</u></button
                  ><br />
                </td>
              </tr>
            </table>
          </b-col>
        </b-row>
      </div>
      <!-- .row -->
      <div class="data-table row mt-5 mt-md-5" v-if="typeReport === 1">
        <div class="col-12">
          <div v-if="loading" id="loader"></div>
          <div v-else class="table-responsive">
            <datatable
              :columns="datatable.columns"
              :data="datatable.rows"
              :filter="datatable.filter"
              :per-page="datatable.perPage"
              :page="datatable.page"
            >
              <template slot-scope="{ row, columns }">
                <tr @click="funcion(row)">
                  <template>
                    <datatable-cell
                      v-for="(column, j) in columns"
                      :key="j"
                      :column="column"
                      :row="row"
                    >
                    </datatable-cell>
                  </template>
                </tr>
              </template>
            </datatable>
            <div
              class="col-12 cont-pagination my-5 d-flex justify-content-center"
            >
              <Pagination
                :data="demands.data"
                :limit="10"
                @pagination-change-page="getFilterAdv"
              ></Pagination>
              <!-- <datatable-pager v-model="datatable.page" type="short" :per-page="datatable.perPage"></datatable-pager> -->
            </div>
            <div class="cont-no-data" v-show="demands.data.data.length <= 0">
              <div class="col-12 col-md-8 col-lg-7 mx-auto mt-3">
                <img
                  src="@/assets/images/demands/user-mail.svg"
                  alt="user email"
                  width="100%"
                />
              </div>
            </div>
          </div>
        </div>
        <small v-show="error.flag" class="alert-danger">{{
          error.message
        }}</small>
        <!-- .col-12 -->
        <div class="col-12 col-md-6 text-left cont-pagintation">
          <!-- <p class="text-1">Mostrando {{datatable.page}} - {{datatable.perPage}} de {{countAllDemands}} Solicitudes</p> -->
        </div>
        <!-- .col -->
        <div
          class="col-12 col-md-6 form-inline cont-pagintation text-left text-md-right"
        >
          <!--datatable-pager v-model="datatable.page" type="abbreviated" :per-page="datatable.perPage"></datatable-pager-->
          <!-- <ul>
            <li v-for="data in demands.data" :key="data.id">{{ data.reason}}</li>
          </ul>
          <Pagination :data="demands"></Pagination> -->
        </div>
      </div>

      <div class="data-table row mt-5 mt-md-5" v-if="typeReport === 2">
        <div class="col-12">
          <div v-if="loading2" id="loader"></div>
          <div v-else class="table-responsive">
            <datatable
              :columns="datatableDP.columns"
              :data="datatableDP.rows"
              :filter="datatableDP.filter"
              :per-page="datatableDP.perPage"
              :page="datatableDP.page"
            >
              <template slot-scope="{ row, columns }">
                <tr @click="funcion2(row)">
                  <template>
                    <datatable-cell
                      v-for="(column, j) in columns"
                      :key="j"
                      :column="column"
                      :row="row"
                    >
                    </datatable-cell>
                  </template>
                </tr>
              </template>
            </datatable>
            <div
              class="col-12 cont-pagination my-5 d-flex justify-content-center"
            >
              <Pagination
                :data="rightPetition.data"
                :limit="10"
                @pagination-change-page="getFilterDp"
              ></Pagination>
            </div>
            <!-- <div class="col-12 col-md-6 cont-pagination">
              <datatable-pager v-model="datatableDP.page" type="short" :per-page="datatable.perPage"></datatable-pager>
            </div> -->

            <div class="cont-no-data" v-show="datatableDP.rows.length <= 0">
              <div class="col-12 col-md-8 col-lg-7 mx-auto mt-3">
                <img
                  src="@/assets/images/demands/user-mail.svg"
                  alt="user email"
                  width="100%"
                />
              </div>
            </div>
          </div>
        </div>
        <small v-show="error.flag" class="alert-danger">{{
          error.message
        }}</small>
        <!-- .col-12 -->
        <div class="col-12 col-md-6 text-left cont-pagintation">
          <!-- <p class="text-1">Mostrando {{datatableDP.page}} - {{datatableDP.perPage}} de {{countAllDemandsDP}} Solicitudes</p> -->
        </div>
        <!-- .col -->
        <div
          class="col-12 col-md-6 form-inline cont-pagintation text-left text-md-right"
        >
          <!--datatable-pager v-model="datatable.page" type="abbreviated" :per-page="datatable.perPage"></datatable-pager-->
        </div>
      </div>

      <div>
        <b-modal
          ref="my-modal"
          hide-footer
          centered
          title="Atención al mensaje:"
          no-close-on-backdrop
          @hidden="hideModal"
        >
          <div class="d-block text-center">
            <h3>{{ this.msjModal }}</h3>
          </div>
          <b-button
            class="mt-3"
            variant="outline-danger"
            block
            @click="hideModal"
          >
            Cerrar
          </b-button>
        </b-modal>
      </div>
      <!-- .row -->
      <div class="mb-menu"></div>
    </div>
    <!-- .layout-content -->
    <!-- Modal repoerte consolidado -->
    <div
      v-if="
        canWithCode(
          PS_ROLES.APROBADOR,
          PS_ROLES.BP,
          PS_ROLES.RELACIONES_LABORALES
        )
      "
    >
      <modal-consolidated-report ref="consolidatedReport" />
    </div>
    <!-- end -->
  </div>
  <!-- #page-alldemands -->
</template>

<script>
import MainBarMenu from "@/components/layouts/MainBarMenu.vue";
import HeadingUser from "@/components/user/HeadingUser.vue";
import { mapActions, mapGetters, mapMutations, mapState } from "vuex";
import serverConfig from "../../services/config";
import Pagination from "laravel-vue-pagination";
import { APROBADOR } from "../../common/constants/roles";
import {
  NATIONAL,
  INTERNATIONAL,
  AUTHORIZATIONS_NATIONAL_TICKETS,
  AUTHORIZATIONS_INTERNATIONAL_TICKETS,
  AUTHORIZATIONS_WITHOUT_TICKETS,
} from "@/common/constants/ticket-types";
import { values } from "@/common/permisos-sindicales/labor-union/term-settings";

export default {
  name: "AllDemands",
  components: {
    MainBarMenu,
    HeadingUser,
    Pagination,
    ModalConsolidatedReport: () => import("@/components/demands/Modal"),
    toasterInformative: () =>
      import("@/components/common/toasters/Informative.vue"),
  },
  data: () => ({
    serverPath: serverConfig.permisosURL,
    error: {
      flag: false,
      class: "", //is-invalid
      message: "",
    },
    reportFrom: "",
    reportTo: "",
    maxDate: "",
    userRolView: false,
    userRolView2: false,
    filterDP: {
      id: false,
      state: [],
      page: 1,
      bp: 0,
    },
    loading2: false,
    typeReport: 1,
    typeSol: "",
    oneDay: "",
    fechaIni: "",
    fechaFin: "",
    estado: [],
    msjModal: "",
    flagPath: 0,
    days: ["Dom", "Lun", "Mar", "Mié", "Jue", "Vie", "Sáb"],
    monthNames: [
      "cero",
      "Ene",
      "Feb",
      "Mar",
      "Abr",
      "May",
      "Jun",
      "Jul",
      "Ago",
      "Sep",
      "Oct",
      "Nov",
      "Dic",
    ],
    datatable: {
      filter: "",
      total: 18,
      perPage: 9,
      page: 1,
      last_page: 2,
      columns: [
        {
          label: "ID Solicitud",
          field: "id",
          align: "left",
          sortable: true,
          //interpolate: true,
          headerClass: "theading",
          /*representedAs: ({ idBase }) =>
            `<a href="/${idBase.link}">${idBase.id}</a>`,
            //`<button onclick="this.funcion">${idBase.id}</button>`,
          interpolate: true,*/
        },
        {
          label: "Sindicato",
          field: "laborunion",
          align: "left",
          headerClass: "theading",
        },
        {
          label: "Fecha",
          field: "dateDemand",
          align: "left",
          headerClass: "theading",
        },

        {
          label: "Solicitante",
          field: "petitioner",
          align: "left",
          headerClass: "theading",
        },

        {
          label: "Tiquetes",
          align: "left",
          headerClass: "theading",
          representedAs: ({ ticketStatus }) =>
            `<span class="icon icon-${ticketStatus.icon}"></span> ${ticketStatus.text}`,
          interpolate: true,
        },
        {
          label: "Fecha de permisos",
          field: "permitDate",
          align: "left",
          headerClass: "theading",
        },
        {
          label: "Estado Solicitud",
          align: "left",
          headerClass: "theading",
          representedAs: ({ status }) =>
            `<span class="icon icon-${status.icon}"></span> ${status.text}`,
          interpolate: true,
        },
      ],
      rows: [],
    },
    datatableDP: {
      total: 18,
      filter: "",
      perPage: 9,
      last_page: 2,
      page: 1,
      columns: [
        {
          label: "ID Solicitud",
          field: "id",
          align: "left",
          sortable: true,
          headerClass: "theading",
        },
        {
          label: "Fecha",
          field: "dateDP",
          align: "left",
          headerClass: "theading",
        },
        {
          label: "Categoria",
          field: "category",
          align: "left",
          headerClass: "theading",
        },
        {
          label: "Solicitante",
          field: "uploader",
          align: "left",
          headerClass: "theading",
        },
        {
          label: "Asignado",
          align: "left",
          headerClass: "theading",
          representedAs: ({ subresponsable }) =>
            `<span style="color:${subresponsable.color}">${subresponsable.text}</span>`,
          interpolate: true,
        },
        {
          label: "Estado",
          align: "left",
          headerClass: "theading",
          representedAs: ({ status }) =>
            `<span class="icon icon-${status.icon}"></span> ${status.text}`,
          interpolate: true,
        },
      ],
      rows: [],
    },
    selected_ticket_state: null,
    selected_request_state: null,
    message_of_request_state:
      "Puedes organizar las solicitudes de permisos sindicales aplicando los filtros que estan arriba.",
    processing: false,
    business_partners_selected_ticket_state: null,
    business_partners_selected_request_state: null,
    business_partners_collaborator: null,
    business_partners_star_date: null,
    business_partners_end_date: null,
    selected_labor_union: null,
  }),
  beforeMount() {
    if (
      this.canWithCode(
        this.PS_ROLES.APROBADOR,
        this.PS_ROLES.BP,
        this.PS_ROLES.RELACIONES_LABORALES
      )
    ) {
      this.getMyLaborUnionAction();
    }

    this.userPermissions();
    if (this.$route.params.type === "pending") {
      if (this.getterTicket.show) {
        this.selected_ticket_state = 2;
        return this.apply_filters();
      }

      if (!this.getterTicket.is_mixed) {
        this.selected_ticket_state = this.getterTicket.has_tickets ? 2 : null;
      }
      if (this.getterTicket.type) {
        this.selected_request_state =
          this.getterTicket.type === NATIONAL ? 1 : 2;
      }
    }

    const data = {
      type: this.oneDay,
      range_init: this.fechaIni,
      range_end: this.fechaFin,
      status: this.estado,
      total: this.datatable.total,
      per_page: this.datatable.perPage,
      last_page: this.datatable.last_page,
      page: this.datatable.page,
    };

    this.actGetfilterAdv({ data })
      .then(() => {
        this.loadRows();
      })
      .catch((response) => {
        if (
          this.demands.data.error != undefined &&
          this.demands.data.error.trace.function == "unauthenticated"
        ) {
          this.setUser("");
          localStorage.setItem("token", "");
          this.showModal(
            "Su sesión ha terminado o ha iniciado sesión en otro dispositivo, por favor vuelva a ingresar",
            1
          );
        } else {
          this.error.flag = true;
          this.error.class = "is-invalid";
          this.error.message =
            "No se pudo conectar al servicio: error: " + response;
        }
      });
  },
  computed: {
    ...mapState("modCore", ["user"]),
    ...mapState("modDemands", ["demands", "loading"]),
    ...mapState("modSettle", ["rightPetition"]),
    ...mapGetters("modLicenseTickets", ["getterTicket"]),
    ...mapGetters("modLicenseTickets", ["getterTicket"]),
    ...mapGetters("modSettings", [
      "getterAuthorizationsTime",
      "getterProcessing",
    ]),
    ...mapGetters("permisosSindicalesV2LaborUnion", [
      "getMyLaborUnionGetter",
      "getSettingGetter",
    ]),
    //# mapea los datos para ser usados por el select
    mapperOfMyLaborUnionGetter() {
      let result = [
        {
          value: null,
          text: "Sindicatos",
          disabled: true,
        },
      ];
      this.getMyLaborUnionGetter.map(({ id, name }) => {
        result.push({
          value: id,
          text: name,
        });
      });
      return result;
    },

    countAllDemands() {
      return this.datatable.rows.length;
    },
    countAllDemandsDP() {
      return this.datatableDP.rows.length;
    },
    /***
     * Lista de estados de solicitudes
     ***/
    list_request_status() {
      // ## generales
      const default_ = [
        {
          value: null,
          text: "Permisos",
          disabled: true,
        },
        {
          value: 1,
          text: "Con tiquetes Nacionales",
          value_send: NATIONAL,
          message:
            "Recuerda que las solicitudes de permisos sindicales con tiquetes nacionales deben ser gestionados mínimo con :value días hábiles de anterioridad de la fecha de inicio del permiso, de no ser así, serán aprobados automáticamente.",
        },
        {
          value: 2,
          text: "Con tiquetes Internacionales",
          value_send: INTERNATIONAL,
          message:
            "Recuerda que las solicitudes de permisos sindicales con tiquetes internacionales deben ser gestionados mínimo con :value días hábiles de anterioridad de la fecha de inicio del permiso, de no ser así, serán aprobados automáticamente.",
        },
        {
          value: 3,
          text: "Sin tiquetes",
          value_send: "no_aplica",
          message:
            "Recuerda que las solicitudes de permisos sindicales sin tiquetes deben ser gestionados mínimo con :value días hábiles de anterioridad de la fecha de inicio del permiso, de no ser así, serán aprobados automáticamente faltando 1 día hábil de la fecha del permiso solicitado.",
        },
      ];
      if (this.selected_labor_union) {
        // ## selecciona el select por medio del id y luego toma el valor del texto
        const component = document.getElementById("input-select-labor-union");
        const nameSelect =
          component.options[component.selectedIndex].text.toLowerCase();
        // ## en caso de que tenga que incluya un acuerdo personalizado
        if (values[nameSelect]) {
          const getFunction = values[nameSelect];
          if (typeof getFunction === "function") return getFunction(default_);
        }
      }
      return default_;
    },
    /***
     * Lista de estados de tiquetes
     ***/
    list_ticket_status() {
      return [
        {
          value: null,
          text: "Solicitudes",
          disabled: true,
        },
        {
          value: 1,
          value_send: "managed",
          text: "Gestionadas",
        },
        {
          value: 2,
          value_send: "not_managed",
          text: this.is_role(APROBADOR) ? "Pendiente" : "Sin gestionar",
        },
      ];
    },
    /**
     * Habilitar los botones del filtro
     **/
    disable_button_to_filter() {
      return (
        this.processing ||
        (!this.selected_ticket_state &&
          !this.selected_request_state &&
          !this.selected_labor_union)
      );
    },
    business_partners_disable_button_to_filter() {
      return (
        this.processing ||
        !!(
          !this.business_partners_selected_ticket_state &&
          !this.business_partners_selected_request_state &&
          !this.business_partners_collaborator &&
          !this.business_partners_star_date &&
          !this.business_partners_end_date &&
          !this.selected_labor_union
        )
      );
    },
    // #Valores que se enviar por defecto cuando se seleccione un estado o no
    getValueSendToChangeRequestState() {
      const values = {
        1: AUTHORIZATIONS_NATIONAL_TICKETS,
        2: AUTHORIZATIONS_INTERNATIONAL_TICKETS,
        3: AUTHORIZATIONS_WITHOUT_TICKETS,
      };
      return (
        values[this.selected_request_state] || AUTHORIZATIONS_WITHOUT_TICKETS
      );
    },
  },
  watch: {
    //   async selected_request_state () {
    //     console.log(this.selected_labor_union || 0)
    //     console.log(`cambio el selected_request_state  => ${this.getValueSendToChangeRequestState}`)
    //     /*if (this.selected_request_state === 1 ) {
    //       await this.getAuthorizationsTime({ value: AUTHORIZATIONS_NATIONAL_TICKETS })
    //     } else if(this.selected_request_state === 2) {
    //       await this.getAuthorizationsTime({ value: AUTHORIZATIONS_INTERNATIONAL_TICKETS })
    //     } else {
    //       await this.getAuthorizationsTime({ value: AUTHORIZATIONS_WITHOUT_TICKETS })
    //     }
    //     this.change_select_request_state(this.selected_request_state)*/
    //   }
  },
  methods: {
    ...mapActions("modDemands", ["actGetfilterAdv", "actDownloadFile"]),
    ...mapActions("modSettle", [
      "actGetRightPetition",
      "actFilterRightPetition",
    ]),
    ...mapActions("modLicenseTickets", ["getCount"]),
    ...mapActions("modSettings", ["getAuthorizationsTime"]),
    ...mapActions("modLicenseTickets", ["getCount"]),
    ...mapMutations("modCore", ["setUser"]),
    ...mapActions("permisosSindicalesV2LaborUnion", [
      "getMyLaborUnionAction",
      "getSettingAction",
    ]),

    // ## se dispara cuando se cambia el sindicato
    change_select_request_labor_union() {
      this.change_select_request_state(this.selected_request_state);
    },

    /**
     * Resetea los filtros
     */
    businessPartnerResetFilters() {
      this.business_partners_selected_ticket_state = null;
      this.business_partners_selected_request_state = null;
      this.business_partners_collaborator = null;
      this.business_partners_star_date = null;
      this.business_partners_end_date = null;
      this.selected_labor_union = null;
      this.get_database(this.reset_data());
    },

    /**
     *
     * Aplica los filtros
     */
    businessPartnerApplyFilters(page = 1) {
      page = page.type ? 1 : page;
      const query = {};

      if (this.business_partners_selected_ticket_state) {
        if (
          this.list_ticket_status[this.business_partners_selected_ticket_state]
        ) {
          query.by_business_partners_ticket_state =
            this.list_ticket_status[
              this.business_partners_selected_ticket_state
            ].value_send;
        }
      }

      if (this.business_partners_selected_request_state) {
        if (
          this.list_request_status[
            this.business_partners_selected_request_state
          ]
        ) {
          query.by_business_partners_ticket_type =
            this.list_request_status[
              this.business_partners_selected_request_state
            ].value_send;
        }
      }

      if (this.business_partners_collaborator) {
        query.by_business_partners_collaborator =
          this.business_partners_collaborator;
      }

      if (this.business_partners_star_date) {
        query.by_business_partners_start_date =
          this.business_partners_star_date;
      }

      if (this.business_partners_end_date) {
        query.by_business_partners_end_date = this.business_partners_end_date;
      }

      if (this.selected_labor_union) {
        query.labor_union = this.selected_labor_union;
      }

      this.get_database(this.reset_data(page), query);
    },

    /***
     * Mensaje que se muestra en la alerta dependiendo del tiquete
     * **/
    async change_select_request_state(event) {
      if (event != null) {
        await this.getSettingAction({
          id: this.selected_labor_union || 0,
          key: this.getValueSendToChangeRequestState,
        });
        if (this.list_request_status[event]) {
          return (this.message_of_request_state = this.list_request_status[
            event
          ].message.replace(":value", this.getSettingGetter.value));
        }
      }
      return (this.message_of_request_state =
        "Puedes organizar las solicitudes de permisos sindicales aplicando los filtros que están arriba.");
    },

    /**
     * Reiniciar los filtros
     **/
    reset_filters() {
      if (
        this.selected_ticket_state != null ||
        this.selected_request_state != null ||
        this.selected_labor_union != null
      ) {
        this.selected_ticket_state = null;
        this.selected_request_state = null;
        this.selected_labor_union = null;
        this.change_select_request_state(null);
        this.get_database(this.reset_data());
      }
    },

    /**
     * Aplicar filtros
     **/
    apply_filters(page = 1) {
      page = page.type ? 1 : page;
      let query = {};
      if (this.selected_ticket_state != null) {
        if (this.list_ticket_status[this.selected_ticket_state]) {
          query.tikect_status =
            this.list_ticket_status[this.selected_ticket_state].value_send;
        }
      }
      if (this.selected_request_state != null) {
        if (this.list_request_status[this.selected_request_state]) {
          query.tickets_type =
            this.list_request_status[this.selected_request_state].value_send;
        }
      }
      if (this.selected_labor_union) {
        query.labor_union = this.selected_labor_union;
      }
      this.get_database(this.reset_data(page), query);
    },

    /***
     * Resetiando los datos para enviarlos a action
     ***/
    reset_data(page = 1) {
      return {
        type: this.oneDay,
        range_init: this.fechaIni,
        range_end: this.fechaFin,
        status: this.estado,
        page,
        filter: this.datatable.filter,
      };
    },

    /***
     * Obtener datos de la base de datos
     ***/
    async get_database(data, query = {}) {
      this.processing = true;
      // await this.getCount()
      await this.actGetfilterAdv({ data, query })
        .then(() => {
          this.datatable.rows = [];
          this.loadRows();
        })
        .finally(() => {
          this.processing = false;
        });
    },

    userPermissions() {
      if (
        this.user.core_role_id === 4 ||
        this.user.core_role_id === 8 ||
        this.user.core_role_id === 9 ||
        this.user.core_role_id === 10
        // this.user.core_role_id === 2
      ) {
        this.userRolView = true;
        if (
          this.user.core_role_id === 4 ||
          this.user.core_role_id === 10
          // this.user.core_role_id === 2
        ) {
          this.userRolView2 = true;
        }
      } else {
        this.userRolView = false;
      }
    },

    maxDateReport() {
      this.maxDate = "";
      let date = new Date(this.reportFrom);
      date.setMonth(date.getMonth() + 4);
      this.maxDate =
        date.getFullYear() + "-" + date.getMonth() + "-" + date.getDate();
    },

    getFilterDp(page) {
      let data2 = [];
      data2 = {
        status: this.filterDP.state,
        page: page,
        filter: this.datatableDP.filter,
        id: this.filterDP.id,
        bp: this.filterDP.bp,
      };
      //alert(JSON.stringify(data));
      this.actGetRightPetition(data2)
        .then(() => {
          this.datatableDP.rows = [];
          this.loadRowsDP();
        })
        .catch((response) => {
          this.error.flag = true;
          this.error.class = "is-invalid";
          this.error.message =
            "No se pudo conectar al servicio: error: " + response;
        });
    },

    getFilterAdv(page) {
      if (this.canWithCode(this.PS_ROLES.BP))
        return this.businessPartnerApplyFilters(page);
      this.apply_filters(page);
      /*let data = [];
      data = {
        'type': this.oneDay,
        'range_init': this.fechaIni,
        'range_end': this.fechaFin,
        'status': this.estado,
        'page': page,
        'filter': this.datatable.filter
      };
      
      //alert(JSON.stringify(data));
      this.actGetfilterAdv({ data }).then(() =>{
            this.datatable.rows = [];
            this.loadRows();
          })
          .catch((response) => {
            this.error.flag = true;
            this.error.class = "is-invalid";
            this.error.message = "No se pudo conectar al servicio: error: "+response;
          });*/
    },

    loadRows() {
      let statusTikets = [];
      let statusRequest = [];
      const { id } = this.user;

      const dataService = this.demands.data;
      this.$store.state.demands = this.demands.data;
      for (let i = 0; i < dataService.data.length; i++) {
        let cont = 0;

        // Tiquetes
        for (let j = 0; j < dataService.data[i].license_employees.length; j++) {
          if (
            dataService.data[i].license_employees[j].ticket.status == "pending"
          ) {
            for (
              let l = 0;
              l < dataService.data[i].license_employees[j].days.length;
              l++
            ) {
              if (
                dataService.data[i].license_employees[j].days[l].status !=
                "rejected"
              ) {
                statusTikets[i] = {
                  icon: "circle-clock",
                  text: "Pendiente",
                };
                cont = 1;
              }
            }
          }
        }
        if (cont == 0) {
          statusTikets[i] = {
            icon: "circle-check",
            text: "Gestionado",
          };
        }

        if (dataService.data[i].tickets === 0) {
          statusTikets[i] = {
            icon: "deny",
            text: "No Aplica",
          };
        }

        //Estado solicitud

        if (this.is_role(APROBADOR)) {
          const { license_employees } = dataService.data[i];
          license_employees.forEach(function ({ approver_id, status }) {
            if (id === approver_id) {
              if (status !== "pending") {
                return (statusRequest[i] = {
                  icon: "circle-check",
                  text: "Gestionado",
                });
              }
              statusRequest[i] = {
                icon: "circle-clock",
                text: "Pendiente",
              };
            }
          });
        } else {
          if (dataService.data[i].status === "closed") {
            statusRequest[i] = {
              icon: "circle-check",
              text: "Cerrado",
            };
          }
          if (dataService.data[i].status === "pending") {
            statusRequest[i] = {
              icon: "circle-clock",
              text: "Pendiente",
            };
          }
          if (dataService.data[i].status === "review") {
            statusRequest[i] = {
              icon: "eye",
              text: "En revisión",
            };
          }
          if (dataService.data[i].status === "canceled") {
            statusRequest[i] = {
              icon: "deny",
              text: "Cancelado",
            };
          }
          if (dataService.data[i].status === "cancelled") {
            statusRequest[i] = {
              icon: "deny",
              text: "Cancelado",
            };
          }
        }

        /*if(dataService.data[i].status == "closed"){
          statusRequest[i] = {
            icon: "circle-check",
            text: "Cerrado",
          }
        }
        if(dataService.data[i].status == "pending"){
          statusRequest[i] = {
            icon: "circle-clock",
            text: "Pendiente",
          }
        }
        if(dataService.data[i].status == "review"){
          statusRequest[i] = {
            icon: "eye",
            text: "En revisión",
          }
        }
        if(dataService.data[i].status == "canceled"){
          statusRequest[i] = {
            icon: "deny",
            text: "Cancelado",
          }
        }
        if(dataService.data[i].status == "cancelled"){
          statusRequest[i] = {
            icon: "deny",
            text: "Cancelado",
          }
        }*/
      }

      //Orden Descendente
      /*for(let i=dataService.data.length-1; i>=0; i--){
        this.datatable.rows.push({
          "id": dataService.data[i].id,
          "dateDemand": this.formatDateShow(dataService.data[i].created_at),//.substring(0, 10),
          "laborunion": dataService.data[i].labor_union.name,
          "petitioner": dataService.data[i].petitioner.name,
          "ticketStatus": statusTikets[i],
          "permitDate": this.formatDateString(dataService.data[i].startDate)+" a "+this.formatDateString(dataService.data[i].endDate),
          "status": statusRequest[i]
        });
      }*/

      //Orden Ascendente
      for (let i = 0; i < dataService.data.length; i++) {
        this.datatable.rows.push({
          id: dataService.data[i].id,
          dateDemand: this.formatDateShow(dataService.data[i].created_at), //.substring(0, 10),
          laborunion: dataService.data[i].labor_union_name,
          petitioner: dataService.data[i].petitioner_name,
          ticketStatus: statusTikets[i],
          permitDate:
            this.formatDateString(dataService.data[i].startDate) +
            " a " +
            this.formatDateString(dataService.data[i].endDate),
          status: statusRequest[i],
        });
      }
    },

    loadRowsDP() {
      let statusSubresponsible = [];
      let statusRequest = [];
      const dataService = this.rightPetition.data;

      for (let i = 0; i < dataService.data.length; i++) {
        //Estado Subresponsable
        if (dataService.data[i].subresponsible == null) {
          statusSubresponsible[i] = {
            color: "#cccccc",
            text: "Sin Asignar",
          };
        } else {
          statusSubresponsible[i] = {
            color: "black",
            text: dataService.data[i].subresponsible,
          };
        }
      }

      for (let i = 0; i < dataService.data.length; i++) {
        //Estado solicitud
        if (dataService.data[i].status == "closed") {
          statusRequest[i] = {
            icon: "circle-check",
            text: "Cerrado",
          };
        }
        if (dataService.data[i].status == "open") {
          statusRequest[i] = {
            icon: "circle-clock",
            text: "Abierta",
          };
        }
        if (dataService.data[i].status == "pending") {
          statusRequest[i] = {
            icon: "circle-clock",
            text: "Pendiente",
          };
        }
        if (dataService.data[i].status == "closing") {
          statusRequest[i] = {
            icon: "eye",
            text: "Cerrando",
          };
        }
      }

      //Orden Descendente
      /*for(let i=dataService.data.length-1; i>=0; i--){
        this.datatableDP.rows.push({
          "id": dataService.data[i].id,
          "dateDP": this.formatDateShow(dataService.data[i].created_at),//.substring(0, 10),
          "category": dataService.data[i].category_name,
          "uploader": dataService.data[i].core_role_name,
          "subresponsable": statusSubresponsible[i],
          "status": statusRequest[i]
        });
      }*/
      //Orden Acendente
      for (let i = 0; i < dataService.data.length; i++) {
        this.datatableDP.rows.push({
          id: dataService.data[i].id,
          dateDP: this.formatDateShow(dataService.data[i].created_at), //.substring(0, 10),
          category: dataService.data[i].category_name,
          uploader: dataService.data[i].core_role_name,
          subresponsable: statusSubresponsible[i],
          status: statusRequest[i],
        });
      }
    },

    tipoSolicitud(id) {
      this.typeReport = id;
      this.loading2 = true;
      this.datatableDP.rows = [];
      if (this.typeReport === 2) {
        let data2 = [];
        data2 = {
          status: this.filterDP.state,
          page: 1,
          filter: this.datatableDP.filter,
          id: this.filterDP.id,
          bp: this.filterDP.bp,
        };
        this.actGetRightPetition(data2).then(() => {
          this.loadRowsDP();
          this.loading2 = false;
        });
      } else {
        let data = [];
        data = {
          type: this.oneDay,
          range_init: this.fechaIni,
          range_end: this.fechaFin,
          status: this.estado,
          total: this.datatable.total,
          per_page: this.datatable.perPage,
          last_page: this.datatable.last_page,
          page: this.datatable.page,
        };

        //alert(JSON.stringify(data));
        this.actGetfilterAdv({ data }).then(() => {
          this.datatableDP.rows = [];
          this.loadRows();
        });
      }
    },

    funcion(row) {
      // 'record' will be the row data from items
      // `index` will be the visible row number (available in the v-model 'shownItems')
      if (row.status.text != "Cancelado") {
        if (this.user.core_role_id === 2 || this.user.core_role_id === 1) {
          // Rol Solicitante y BP
          this.$router.push({ path: "/consulrequest/" + row.id });
        }
        if (
          this.user.core_role_id === 7 ||
          this.user.core_role_id === 4 ||
          this.user.core_role_id === 10
        ) {
          // Rol RRLL Tiquetes
          this.$router.push({ path: "/approverTks/" + row.id });
        }
        if (this.user.core_role_id === 3) {
          // Rol aprobador solicitud
          this.$router.push({ path: "/approverSol/" + row.id });
        }
      }
    },

    downloadFile(link) {
      //alert(link);
      this.actDownloadFile(link).then((response) => {
        //alert(response);
        this.file = response;

        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(
          new Blob([this.file], { type: "application/xlsx" })
        );
        link.setAttribute("download", "reporte.xlsx");
        document.body.appendChild(link);
        link.click();
      });
    },

    funcion2(row) {
      this.$router.push({ path: "/rightPetition/" + row.id });
    },

    formatDateShow(date) {
      var d = new Date(date);
      var anno = d.getFullYear() + "";
      anno = anno.match(/\d{2}$/);
      var datestring =
        d.getDate() + " " + this.monthNames[d.getMonth() + 1] + " " + anno;
      return datestring;
    },

    formatDateString(date) {
      var d = date.split("-");
      var anno = d[0];
      anno = anno.substring(0, 2);
      let mes = parseInt(d[1]);
      var datestring = d[2] + " " + this.monthNames[mes] + " " + anno;
      return datestring;
    },

    showModal(msj, flag) {
      this.msjModal = msj;
      this.flagPath = flag;
      this.$refs["my-modal"].show();
    },
    hideModal() {
      this.$refs["my-modal"].hide();
      if (this.flagPath == 1) {
        this.$router.push({ path: "/" });
      }
    },
  },
};
</script>

<style lang="scss">
/*
  filtros del businness partners
*/
.filters-bp {
  background-color: #e5e5e5;
  min-height: 100%;
  padding-bottom: 25px;
  padding-top: 20px;
}

.btn-reporte {
  color: white;
  background: #1c3a4e;
  border: none;
  padding: 7px 12px 7px 7px;
  border-radius: 8px;
  :hover {
    color: #ffffff;
  }
}
.page-item.active .page-link {
  color: #fff !important;
  background-color: #1c6776 !important;
  border-color: #1c6776 !important;
}
.page-link {
  color: #1c6776 !important;
}
#page-alldemands {
  .data-table {
    tr {
      th {
        &:nth-child(1) {
          min-width: 120px;
        }
        &:nth-child(2) {
          min-width: 170px;
        }
        &:nth-child(3) {
          min-width: 110px;
        }
        &:nth-child(4) {
          min-width: 210px;
        }
        &:nth-child(5) {
          min-width: 110px;
        }
      }
    }
  }
}
</style>

<style lang="scss" scoped>
#page-alldemands {
  .cont-search {
    label {
      font-size: 11px;
      color: #454545;
    }
    .cont-input {
      background: #1c3a4e;
      border-radius: 4px;
      padding: 1px;
      width: fit-content;
      float: left;

      .input-text {
        padding: 8px;
        min-width: 160px;
        border-radius: 4px;
        font-style: italic;
        font-weight: 300;
        font-size: 12px;
        color: #bbbbbb;
        border: 0 none;
        &:focus {
          outline: none;
        }
      }
      button {
        background: transparent;
        border: 0 none;
        color: #ffffff;
      }

      @media (min-width: 768px) {
        float: right;
      }
    }
  }
  a:hover,
  a:focus,
  a:active {
    text-decoration: none;
    color: inherit;
  }
  .button1 {
    font-family: "Open Sans";
    background: #e9ecee;
    color: #1c3a4e;
    font-weight: bold;
    //border-radius: 50px;
    height: 32px;
    font-size: 14px;
    text-align: left !important;
    padding-left: 5%;
    padding-right: 5%;
    outline: none;
    border: none;
    &:hover {
      background: darken(#cddce6, 5);
      border: none;
    }
  }
  .div1 {
    border: 0px solid black;
    margin-top: 0px;
    margin-bottom: 0px;
    margin-right: 40px;
    margin-left: 40px;
  }
  .tabla1 {
    border-radius: 5px;
    border: 3px solid #e9ecee;
    border-color: #e9ecee;
    background: #e9ecee;
    -moz-border-radius: 6px;
    border-collapse: separate;
    border-spacing: 0px;
    padding-left: 5%;
    align-self: left;
  }
  .td1 {
    background: #e9ecee;
    color: #1c3a4e;
    font-family: "Open Sans";
    font-weight: bold;
    font-size: 16px;
    line-height: 19px;
    padding-left: 0%;
    padding-right: 3%;
    width: 100px;
    text-align: left;
  }
  .td2 {
    width: auto;
    background: #e9ecee;
    color: #1c3a4e;
    font-family: "Open Sans";
    font-weight: normal;
    font-style: normal;
    font-size: 13px;
    line-height: 14px;
    //width: 50px;
    text-align: left;
    padding-left: 4%;
    padding-right: 4%;
  }
  .td3 {
    background: #ffffff;
    color: #1c3a4e;
    font-family: "Open Sans";
    font-weight: normal;
    font-style: normal;
    font-size: 13px;
    line-height: 40px;
    //width: 50px;
    text-align: left;
    padding-left: 4%;
    padding-right: 4%;
  }
  .td4 {
    background: #1c3a4e;
    color: #ffffff;
    font-family: "Open Sans";
    //font-weight: bold;
    font-size: 12px;
    line-height: 25px;
    padding-left: 1%;
    padding-right: 1%;
    width: 100px;
    text-align: left;
  }
  .p2 {
    font-family: "Open Sans";
    font-style: normal;
    //font-weight: 600;
    font-size: 14px;
    line-height: 15px;
    color: #454545;
    text-align: left !important;
  }
  .collapsed > .when-opened,
  :not(.collapsed) > .when-closed {
    display: none;
  }
  .centerImg1 {
    width: 16px;
    height: 16px;
    top: 100%;
    float: right;
  }
  .leftImg1 {
    width: 16px;
    height: 16px;
    vertical-align: middle;
  }
  /* Center the loader */
  #loader {
    position: absolute;
    left: 50%;
    top: 50%;
    z-index: 1;
    width: 150px;
    height: 150px;
    margin: 85px 0 0 -75px;
    border: 16px solid #f3f3f3;
    border-radius: 50%;
    border-top: 16px solid #3498db;
    width: 120px;
    height: 120px;
    -webkit-animation: spin 2s linear infinite;
    animation: spin 2s linear infinite;
  }

  @-webkit-keyframes spin {
    0% {
      -webkit-transform: rotate(0deg);
    }
    100% {
      -webkit-transform: rotate(360deg);
    }
  }

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }

  /* Add animation to "page content" */
  .animate-bottom {
    position: relative;
    -webkit-animation-name: animatebottom;
    -webkit-animation-duration: 1s;
    animation-name: animatebottom;
    animation-duration: 1s;
  }

  @-webkit-keyframes animatebottom {
    from {
      bottom: -100px;
      opacity: 0;
    }
    to {
      bottom: 0px;
      opacity: 1;
    }
  }

  @keyframes animatebottom {
    from {
      bottom: -100px;
      opacity: 0;
    }
    to {
      bottom: 0;
      opacity: 1;
    }
  }

  #myDiv {
    display: none;
    text-align: center;
  }
  .mycheck {
    vertical-align: middle;
    position: relative;
    bottom: 1px;
  }
  @media only screen and (max-width: 600px) {
    .td2 {
      width: 33%;
    }
  }

  i.circle {
    display: inline-block;
    border-radius: 60px;
    box-shadow: 0 0 2px #888;
  }
}
</style>
